<SettingsLayout page="settings">
  <h1 class="dynamic-page-title settings-page-title">
    <SvgIcon className="settings-page-title-icon" href="#fa-gear" />
    <span>{$messages["settings"]}</span>
  </h1>

  <h2 class="settings-section-title">
    {$messages["general"]}
  </h2>

  <SettingsList>
    <SettingsListRow>
      <SettingsListButton href="/settings/general" label="{$messages["general"]}"/>
    </SettingsListRow>
    <SettingsListRow>
      {#if singleInstance}
        <SettingsListButton href="/settings/account" label="{$messages["account"]}"/>
      {:else}
        <SettingsListButton href="/settings/instances" label="{$messages["instances"]}"/>
      {/if}
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="/settings/hotkeys" label="{$messages["hotkeys"]}"/>
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="/settings/about" label="{$messages["aboutApp"]}"/>
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="/settings/logs" label="{$messages["logs"]}"/>
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="#" on:click="reload(event)" label="{$messages["reload"]}"/>
    </SettingsListRow>
  </SettingsList>

  <CommunitySettingsSection/>
</SettingsLayout>

<style>
  .settings-page-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 2em;
    font-weight: 400;
    line-height: 1.2;
    margin: 0 0 28px;
  }

  .settings-page-title span {
    position: relative;
    left: -2px;
  }

  :global(.settings-page-title-icon) {
    width: 32px;
    height: 32px;
    flex: 0 0 auto;
    fill: currentColor;
  }

  .settings-section-title {
    font-size: 23px;
    font-weight: 400;
    line-height: 1.3;
    margin: 0 0 18px;
  }
</style>

<script>
  import { getSingleInstance } from '../../_utils/getSingleInstance.js'
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'
  import SettingsList from '../../_components/settings/SettingsList.html'
  import SettingsListRow from '../../_components/settings/SettingsListRow.html'
  import SettingsListButton from '../../_components/settings/SettingsListButton.html'
  import CommunitySettingsSection from '../../_components/settings/CommunitySettingsSection.html'
  import SvgIcon from '../../_components/SvgIcon.html'

  export default {
    components: {
      SettingsLayout,
      SettingsList,
      SettingsListRow,
      SettingsListButton,
      SvgIcon,
      CommunitySettingsSection
    },
    methods: {
      async reload (event) {
        event.preventDefault()
        try {
          await Promise.all((await navigator.serviceWorker.getRegistrations()).map(e => e.unregister()))
        } catch (e) {
          console.error(e)
        }
        document.location.reload(true)
      }
    },
    data: () => ({
      singleInstance: getSingleInstance()
    })
  }
</script>
